import React from 'react'

interface LayoutContextValue {
  navState: boolean
  setNavHandle?: () => void
}

export const LayoutContext = React.createContext<LayoutContextValue>({
  navState: false,
})

export const useLayoutContext = () => React.useContext(LayoutContext)

export const drawerWidth = 80
